const WORLD_CUP_STYLE_VALUES = new Set(['rope', 'figaro', 'cuban', 'franco', 'anchor']);

const WORLD_CUP_ASSIGNED_MEDIA_KEYS = {
  'canada|rope': ["001-canada-rope-assigned", "949efdf0-0796-4a99-afd7-273c2c614492", "80cc171b-c002-4482-b94e-b33a6faeafdf"],
  'canada|figaro': ["003-canada-figaro-assigned", "e257a29e-e5f0-42ec-80d1-c6a3c9aaf950", "310078c4-e524-49c2-9757-dbf39296c2e2"],
  'canada|cuban': ["005-canada-cuban-assigned", "0118e6a2-33fe-4879-be9b-098474de61a5", "c431cf85-1c22-4f5a-a5f9-ea0d1d3ed99e"],
  'canada|franco': ["007-canada-franco-assigned", "a1bfd9fe-c8a3-43a4-bd3c-2b8c025fe810"],
  'canada|anchor': ["009-canada-anchor-assigned", "a6e923e4-1672-4a63-90a4-05086e67efc2"],
  'usa|rope': ["011-usa-rope-assigned", "2085f546-447c-490a-a8c0-7538f852b9c4", "f2b837d4-607e-421d-b206-8e100b7c6466"],
  'usa|figaro': ["013-usa-figaro-assigned", "860727d7-68a6-4fd7-a2ce-0b316f187d45", "58d9d118-4ff0-4ae6-9c3d-226fc9e9ab27"],
  'usa|cuban': ["015-usa-cuban-assigned", "c9eb81fb-5b6a-4af0-8f08-d94813c5a266", "e3e89423-dabb-47aa-9c18-0dc762cbd1f4"],
  'usa|franco': ["017-usa-franco-assigned", "6fcc70c9-9af1-4282-b075-ea547127fe2a"],
  'usa|anchor': ["019-usa-anchor-assigned", "4fe2f8c6-123a-4a2e-a5bb-aa63f50c254c"],
  'morocco|rope': ["021-morocco-rope-assigned", "28dcc09e-acf4-4756-8773-ba31fd22651d", "a3cc8ec3-f508-43ba-8265-8aaf114d27a5"],
  'morocco|figaro': ["023-morocco-figaro-assigned", "748503a0-f40e-4842-bb93-5c394fcb0d17", "24372fbe-89d4-4100-85c5-eaa3785ff9e9"],
  'morocco|cuban': ["025-morocco-cuban-assigned", "889efb23-2435-41bb-a59f-8d06fcbac0e4", "2c1541c5-3f7d-41b0-92dd-d047b2f73c6d"],
  'morocco|franco': ["027-morocco-franco-assigned", "503ac8f0-3a7c-48bb-a1b8-72fa69ef3230"],
  'morocco|anchor': ["029-morocco-anchor-assigned", "78ce466f-4fad-4b8d-abc0-1dd15f936eb3"],
  'mexico|rope': ["031-mexico-rope-assigned", "b87e6590-cb84-4189-99dc-8aee075e7317", "f3681c2f-c94d-4640-8354-f24276992b1b"],
  'mexico|figaro': ["033-mexico-figaro-assigned", "9ffa49ff-194c-4292-8e3c-9b76d4b79211", "46cb510e-9483-4bdb-a835-d44a5568e801"],
  'mexico|cuban': ["035-mexico-cuban-assigned", "f36f41b8-5646-4317-b04b-d7d155804bed", "f71e41c0-dfd5-4db6-b2b3-0a04851ff575"],
  'mexico|franco': ["037-mexico-franco-assigned", "e33f60cb-3abe-418d-8f76-06d5a09354a1"],
  'mexico|anchor': ["039-mexico-anchor-assigned", "637dcb5e-8d43-4e49-83af-b86dd052f2c9"],
  'argentina|rope': ["041-argentina-rope-assigned", "d4ef0e0d-13af-4a77-9a61-96f024b3ae08", "3b42409a-08f5-4518-9aa2-163fd7f67126"],
  'argentina|figaro': ["043-argentina-figaro-assigned", "b4a33fed-c8c9-4dd2-bac2-81bf3623f5ef", "a07719bb-01cc-4030-bc32-12f3e82e3825"],
  'argentina|cuban': ["045-argentina-cuban-assigned", "6c58e39f-34d3-4550-8980-a986509fd641", "d1bd1965-b1d5-4093-914c-243306c3776f"],
  'argentina|franco': ["047-argentina-franco-assigned", "8e208b45-f885-4ae2-b148-342133e7ed6d"],
  'argentina|anchor': ["049-argentina-anchor-assigned", "68e43d15-2737-4049-97b1-8034876df35d"],
  'netherlands|rope': ["051-netherlands-rope-assigned", "0498c097-4ba4-4a7f-b852-9ec82aa3a574", "432bce02-b184-46bd-b41d-032e3327b77c"],
  'netherlands|figaro': ["053-netherlands-figaro-assigned", "44d29ec2-0362-4ba1-b2d1-7a1b102d00f5", "fae2ac48-9738-4c1c-b17f-c82b5bde2747"],
  'netherlands|cuban': ["055-netherlands-cuban-assigned", "6796a01a-5f21-4090-ba9e-bfa06b2a3f45", "799ec3db-7cdb-49b1-8043-a4cb4c927b64"],
  'netherlands|franco': ["057-netherlands-franco-assigned", "9d1110bd-c423-4342-91e7-88b46fb8ce97"],
  'netherlands|anchor': ["059-netherlands-anchor-assigned", "4dfc216a-8261-4143-bba3-df6e319bd7ef"],
  'spain|rope': ["061-spain-rope-assigned", "5d69788f-76c7-462c-9dfd-18e81ff45d30", "67a0a927-46d6-44f9-bf58-f8c2adfb10e9"],
  'spain|figaro': ["063-spain-figaro-assigned", "80854cb5-bbcd-439c-a4c1-2a55918b18a0", "872f4a55-6c68-404d-82e7-23c258f2ab88"],
  'spain|cuban': ["065-spain-cuban-assigned", "24c16392-962d-4ad6-84d0-6e3f55c75544", "4a870aab-00b5-4381-9d9e-e3dd8a77d1fb"],
  'spain|franco': ["067-spain-franco-assigned", "e953484a-d030-495c-8f53-115942bcc4d4"],
  'spain|anchor': ["069-spain-anchor-assigned", "e127670e-e102-4a06-bb17-57a1ed5b8c39"],
  'portugal|rope': ["071-portugal-rope-assigned", "c88a83df-d6e1-4be7-9824-a03d3e43bdde", "58d41350-c424-43eb-994d-2745ee00759c"],
  'portugal|figaro': ["073-portugal-figaro-assigned", "f5d50c94-2122-4405-a619-23fb8f004fa1", "45778c5d-adef-4b17-9df0-aeb8f7d3215d"],
  'portugal|cuban': ["075-portugal-cuban-assigned", "1b860f40-6d54-4dec-9e0e-d7f4cbee5e33", "e4ff0dd4-ef21-40b9-99ec-768cebf01b97"],
  'portugal|franco': ["077-portugal-franco-assigned", "bd8302d7-a3d5-42f0-adfc-f1224aab511f"],
  'portugal|anchor': ["079-portugal-anchor-assigned", "823cbc68-2ccd-48e4-a6fe-59b385cef8e2"],
  'france|rope': ["081-france-rope-assigned", "5d014031-a762-4b1c-aeb6-70aac247e7fa", "ca8352b8-9ae2-4e21-8d72-977eb4e407e5"],
  'france|figaro': ["083-france-figaro-assigned", "58fb1934-8f94-477e-8caf-2025c7bd6daf", "b8f2db22-3839-4472-af99-56d89c0a2fb6"],
  'france|cuban': ["085-france-cuban-assigned", "78d73e1c-020c-4fdc-83f4-fb36bf934051", "6e5b7f84-c399-40ea-9b7f-a800addb2425"],
  'france|franco': ["087-france-franco-assigned", "265fcc69-722d-4330-9e1b-07c03bba7abd"],
  'france|anchor': ["089-france-anchor-assigned", "7e50fb11-cb25-40b5-b16e-31d0fec1c10f"],
  'croatia|rope': ["091-croatia-rope-assigned", "08fec2d3-ebda-4adc-b7e2-951163d6a89c", "3114584c-683a-4638-9db4-cdbb9add7260"],
  'croatia|figaro': ["093-croatia-figaro-assigned", "479f476d-decd-487a-9790-ddbf12dd7795", "168ed7ef-3d63-41d6-9f98-11b625e059f2"],
  'croatia|cuban': ["095-croatia-cuban-assigned", "82c2ebcb-0df6-4dbf-9f85-9823938a36f6", "5973a276-84ca-4cdc-89ad-f80b68b57606"],
  'croatia|franco': ["097-croatia-franco-assigned", "b6ae768f-23df-4f90-b951-2b56ec5224af"],
  'croatia|anchor': ["099-croatia-anchor-assigned", "1fabb5a6-b13b-40b4-8535-c3c226706ed3"],
  'japan|rope': ["101-japan-rope-assigned", "f4f7647c-81dd-4e36-98a3-3294df93cc48", "3f047e6c-da7a-49f8-aa65-9e6da2328ca6"],
  'japan|figaro': ["103-japan-figaro-assigned", "ca208cc7-27e7-4f84-83e6-5017f7e33070", "c8211893-8954-4f11-b328-da8f1e1af815"],
  'japan|cuban': ["105-japan-cuban-assigned", "822c9809-6995-4166-8c83-231002f56317", "88c9a269-1478-4aa0-b99c-fb406cfe77d2"],
  'japan|franco': ["107-japan-franco-assigned", "32401092-a2ec-470d-b150-7ff7c354a5aa"],
  'japan|anchor': ["109-japan-anchor-assigned", "5805a691-0cc9-47d8-9b05-f5d173bacb52"],
  'iran|rope': ["111-iran-rope-assigned", "c6878f21-5d05-40d3-a8c2-94a439b2e710", "2fbfbb54-bd0d-4821-9c41-e5d30eb158d0"],
  'iran|figaro': ["113-iran-figaro-assigned", "75b1f592-87c7-4581-a945-e7cf6e52f646", "e8cd8b45-0cf3-43c0-991b-215a3d536f78"],
  'iran|cuban': ["115-iran-cuban-assigned", "af8a46ac-bf62-4c30-8a67-7f9e96356db7", "182fb57f-fa18-4287-b193-9ac466ea3f4f"],
  'iran|franco': ["117-iran-franco-assigned", "5d3290bb-e7c7-4b63-a416-af74d8a4a6f7"],
  'iran|anchor': ["119-iran-anchor-assigned", "5cf7039e-50ad-433a-9a65-d273d8adb6f1"],
  'switzerland|rope': ["121-switzerland-rope-assigned", "a43c5715-5b0d-45e2-b0f8-f7094cd929be", "77ae9291-9bc2-42ed-ac09-e7004bd69ff2"],
  'switzerland|figaro': ["123-switzerland-figaro-assigned", "a0b5812f-9cbd-4271-8bce-3dbe017d5922", "6cc7703d-12b9-4e57-bc13-3c7459443b8f"],
  'switzerland|cuban': ["125-switzerland-cuban-assigned", "d518204c-8f84-4a7d-9fce-1c184e2ad752", "cea5865c-e479-4259-b86c-4722f8f27352"],
  'switzerland|franco': ["127-switzerland-franco-assigned", "9fab1b66-80e3-4d2d-9320-b6a4ba3e07aa"],
  'switzerland|anchor': ["129-switzerland-anchor-assigned", "df436ba3-37d9-4667-b4e2-69ad9f4d0ba1"],
  'belgium|rope': ["131-belgium-rope-assigned", "44c36fc3-5287-4906-b06a-636a6579ab03", "8f1c4729-be8b-4f5b-b6c9-16a63f52bfb2"],
  'belgium|figaro': ["133-belgium-figaro-assigned", "007dc4dd-cf55-4e4f-9fa0-8f15cbe6e53b", "dede1416-be39-4417-bfe0-0b8c7cc32b76"],
  'belgium|cuban': ["135-belgium-cuban-assigned", "ad4390a9-1bff-4380-85d9-a175717736cd", "a55657a0-2797-466c-aeba-fa9b848a30b9"],
  'belgium|franco': ["137-belgium-franco-assigned", "a7e99c19-96a4-4290-a6ac-617cd24475f9"],
  'belgium|anchor': ["139-belgium-anchor-assigned", "bca65347-7851-45d7-ac7d-7783d4e206a8"],
  'england|rope': ["141-england-rope-assigned", "7cfc7e54-8997-49ef-9be8-866e1335fd29", "1434dbec-7fb9-470d-bb86-37425d89bc70"],
  'england|figaro': ["143-england-figaro-assigned", "fd03156f-ca5a-47b0-a306-f0ae5cad9c20", "e2845201-8347-4223-8338-95c0e55fc007"],
  'england|cuban': ["145-england-cuban-assigned", "eb273eca-63fc-4b10-a4be-1986b82a30aa", "a824ce50-c6bd-421a-9fe0-73ca89da9a71"],
  'england|franco': ["147-england-franco-assigned", "6ae45cf1-21a2-4983-9513-60f0f8b915aa"],
  'england|anchor': ["149-england-anchor-assigned", "c448a3c8-e029-4b3f-8ea3-4332350403b9"],
  'ivory coast|rope': ["151-ivory-coast-rope-assigned", "a1043823-0d00-44ab-8a33-03d2bdcc3ef9", "99e0c2a7-d141-4eff-8a4d-f612d620f7b4"],
  'ivory coast|figaro': ["153-ivory-coast-figaro-assigned", "843096fb-0aad-4e55-a107-c37381635f25", "dd082307-fe90-49f1-859e-9da56c69e0ef"],
  'ivory coast|cuban': ["155-ivory-coast-cuban-assigned", "ea1539b1-c0a1-4a20-87c4-67c58916a417", "e67e6920-26be-4661-b530-073db62ec13f"],
  'ivory coast|franco': ["157-ivory-coast-franco-assigned", "6dc9eb01-86d8-4680-a7c2-17d047d212b4"],
  'ivory coast|anchor': ["159-ivory-coast-anchor-assigned", "efb0d1ac-847c-4372-bfb5-93e3f5779c75"],
  'colombia|rope': ["161-colombia-rope-assigned", "2003175b-010d-4d70-9895-c2c0790bfd17", "76684466-36ed-495b-8d10-a766d3ec3345"],
  'colombia|figaro': ["163-colombia-figaro-assigned", "a264e0bd-9024-4759-8932-b92f783fa0b3", "3bfa7e8b-8e9f-4b72-a9d1-3c4c3b71c931"],
  'colombia|cuban': ["165-colombia-cuban-assigned", "529474b9-dd94-49ac-856a-aa3b2c09e883", "9b833144-8fcc-44f3-aafe-66efef9dcb70"],
  'colombia|franco': ["167-colombia-franco-assigned", "911a8999-3c1d-4eae-9281-dc1637947f49"],
  'colombia|anchor': ["169-colombia-anchor-assigned", "a0e159db-7596-4fb9-959e-9da4c425e32d"],
  'austria|rope': ["171-austria-rope-assigned", "f10be70c-6576-4e62-a238-d654840ca205", "daed76f8-849b-4d73-aaee-a99e0c4c11df"],
  'austria|figaro': ["173-austria-figaro-assigned", "1acb7993-679b-4f89-a5e3-98b9534e5838", "b2ab4969-b82a-46f8-8c08-d1eb186cde5e"],
  'austria|cuban': ["175-austria-cuban-assigned", "e0ebf35e-2b45-4efc-9cb9-14d185db2d51", "7040b0a4-7e82-49de-bf24-1568450dfd60"],
  'austria|franco': ["177-austria-franco-assigned", "82239ac3-3802-439a-99a4-df3597f4309d"],
  'austria|anchor': ["179-austria-anchor-assigned", "27172cb2-e428-4c8f-863f-f78f5dd50566"],
  'uruguay|rope': ["181-uruguay-rope-assigned", "82efb81e-0ef4-476b-b347-5439766ee1e0", "99f8d6e8-c549-4833-9633-eaa6f39ffabc"],
  'uruguay|figaro': ["183-uruguay-figaro-assigned", "0e0600bf-8d1c-4eb7-9bd8-358d274a08de", "86871072-cb1c-472a-9c7e-86b08277fda4"],
  'uruguay|cuban': ["185-uruguay-cuban-assigned", "8b1de1fb-f847-4b0a-8659-3b033a6f2701", "46a7a2fb-96bc-4cd6-ad63-edc77aeb93bf"],
  'uruguay|franco': ["187-uruguay-franco-assigned", "537951fd-0886-40c2-869b-0fc9de460af6"],
  'uruguay|anchor': ["189-uruguay-anchor-assigned", "c1421c3a-8932-47e0-9275-92296bd4796a"],
  'south korea|rope': ["191-south-korea-rope-assigned", "803e29f6-3536-4675-8c06-958bdd497b72", "cfcb02fe-1655-44c6-a7e2-cf990f98a6e6"],
  'south korea|figaro': ["193-south-korea-figaro-assigned", "dcc50355-a801-4ab1-a244-2d6fd295bfbe", "f0ed7857-9af2-4d9c-bee6-48d63e789360"],
  'south korea|cuban': ["195-south-korea-cuban-assigned", "e6212867-5879-4700-94c0-fb8941f75ae6", "879ced95-1a43-4cc6-a2ee-84276c0258fa"],
  'south korea|franco': ["197-south-korea-franco-assigned", "74f06f16-190f-42de-81fe-c9ee6711f848"],
  'south korea|anchor': ["199-south-korea-anchor-assigned", "b071cfd8-aba7-490d-a036-1ba8ebbcb0a0"],
  'brazil|rope': ["201-brazil-rope-assigned", "979a9763-2b08-4b9f-a78f-89bed1e16455", "e1a2c519-7a3c-473e-89fb-7d9bdc9ed90e"],
  'brazil|figaro': ["203-brazil-figaro-assigned", "c85eb655-2964-482f-a270-f52e693be266", "366e3168-cf9a-444c-b6c7-a57aaf20cac1"],
  'brazil|cuban': ["205-brazil-cuban-assigned", "94a9c921-5669-4c43-8c0d-07fa1dea6966", "934fb274-bb8d-42c4-bda8-e37ce0e6df14"],
  'brazil|franco': ["207-brazil-franco-assigned", "53670e2b-3012-4f6e-a4b7-545525041491"],
  'brazil|anchor': ["209-brazil-anchor-assigned", "970afe19-d5a7-4694-9232-1b1fff5b8f04"],
  'germany|rope': ["211-germany-rope-assigned", "f65da1f8-5c45-478f-b9a7-e090bb6072da", "d73dd42c-47db-40c6-8980-3682f0489d29"],
  'germany|figaro': ["213-germany-figaro-assigned", "1f72fd07-04a2-4467-9629-491db67b81d9", "c2543240-e0b8-470f-9f0e-813ae47c0c32"],
  'germany|cuban': ["215-germany-cuban-assigned", "702b9bb2-25d1-4672-ac58-92abc7f63484", "5bd3ed83-9fcb-40b0-8bde-174a80576641"],
  'germany|franco': ["217-germany-franco-assigned", "24baa7f8-62c5-45b5-bbb1-26c3d7f77474"],
  'germany|anchor': ["219-germany-anchor-assigned", "5054b582-0f10-4ba6-8141-89bc610ba74a"],
};

const WORLD_CUP_MODEL_MEDIA_KEYS = {
  'canada|rope': ["002-canada-rope-model", "4aa1e047-b679-46fb-9fb4-c045d671e7ce"],
  'canada|figaro': ["004-canada-figaro-model", "97d79107-27e8-41e7-a530-5233f3dacd3a"],
  'canada|cuban': ["006-canada-cuban-model", "80c9d3bf-b235-4c69-9c36-2e60313d83e7"],
  'canada|franco': ["008-canada-franco-model", "27a1a753-09fc-4b4b-83a7-a88085907d05"],
  'canada|anchor': ["010-canada-anchor-model", "8a15e01c-9bfc-4458-9a3c-26b961123c8e"],
  'usa|rope': ["012-usa-rope-model", "5e37294b-793d-4283-bde3-76f1f29c8515"],
  'usa|figaro': ["014-usa-figaro-model", "1dd69de2-7717-45dd-872e-762afedf8a6f"],
  'usa|cuban': ["016-usa-cuban-model", "153d0995-8dc3-4fec-a767-e2675293b909"],
  'usa|franco': ["018-usa-franco-model", "584481af-cfc7-438c-8f70-c90efe4a59e7"],
  'usa|anchor': ["020-usa-anchor-model", "50ea0c08-c92e-46c6-a103-7b3a1d8d3d5e", "unnamed"],
  'morocco|rope': ["022-morocco-rope-model", "5dc0145e-0989-4f1e-b4d9-a406a0ee3027"],
  'morocco|figaro': ["024-morocco-figaro-model", "57757101-01bd-47b7-9bd4-dda6813a4173"],
  'morocco|cuban': ["026-morocco-cuban-model", "66fd763c-291b-4be4-9103-5377cf223a2f"],
  'morocco|franco': ["028-morocco-franco-model", "9e7e9a9e-3e5c-4452-b337-a173209d0b5e"],
  'morocco|anchor': ["030-morocco-anchor-model", "eee31cc2-003e-4819-90e2-f39bf4fa63a7"],
  'mexico|rope': ["032-mexico-rope-model", "dc1e8b85-42ee-44c5-be78-ffc03d1fedbc"],
  'mexico|figaro': ["034-mexico-figaro-model", "e960c33e-e222-4524-8d8c-a5ae20b90997"],
  'mexico|cuban': ["036-mexico-cuban-model", "cc0f390f-bc07-45ff-9d9a-324798641660"],
  'mexico|franco': ["038-mexico-franco-model", "464a17ac-f4e3-4979-99ed-f8f3f5b6fcbc"],
  'mexico|anchor': ["040-mexico-anchor-model", "57ee8afe-f646-4551-9a9f-5fbe4b11ad9a"],
  'argentina|rope': ["042-argentina-rope-model", "bf5b4d07-414a-4a80-83de-a7d0374aa61e"],
  'argentina|figaro': ["044-argentina-figaro-model", "8f1c0165-46ca-45f0-b572-56d5c8ce16f4"],
  'argentina|cuban': ["046-argentina-cuban-model", "5f508d00-750a-4eed-a930-d0707fe70323"],
  'argentina|franco': ["048-argentina-franco-model", "e05a1944-c607-47d5-8c62-9ef4149f05da"],
  'argentina|anchor': ["050-argentina-anchor-model", "10ea4ffe-66c2-44c0-b076-0a0c0056aebe"],
  'netherlands|rope': ["052-netherlands-rope-model", "90cb6ad7-27e4-4f2f-9390-57887251da4a"],
  'netherlands|figaro': ["054-netherlands-figaro-model", "5724da7b-e04a-47f8-a21a-14d741c275db"],
  'netherlands|cuban': ["056-netherlands-cuban-model", "a5bff5d0-948c-49dc-a914-f868c33bd72a"],
  'netherlands|franco': ["058-netherlands-franco-model", "a58e0fbf-971b-4c02-bc3a-f3f3be7398e6"],
  'netherlands|anchor': ["060-netherlands-anchor-model", "a0e6249a-5193-42a0-8d18-7df6e6d01c48"],
  'spain|rope': ["062-spain-rope-model", "50f7df6d-6a32-4db7-8bf5-9f7d170589d4"],
  'spain|figaro': ["064-spain-figaro-model", "02b38cc1-831b-4f3c-8731-bdcdebeaf1f9"],
  'spain|cuban': ["066-spain-cuban-model", "a8c32dcd-ee6a-49bb-8a4e-336c3c4a9b1d"],
  'spain|franco': ["068-spain-franco-model", "dbd2571f-7477-4b9d-a94b-9336620c645c"],
  'spain|anchor': ["070-spain-anchor-model", "10f2ee0f-eb06-4862-88a5-55a8147e36c2"],
  'portugal|rope': ["072-portugal-rope-model", "e3bac79a-c485-4e0c-b15a-9f7ab3973d6f"],
  'portugal|figaro': ["074-portugal-figaro-model", "4881326e-4127-4fb5-b4cb-7b31dd0444eb"],
  'portugal|cuban': ["076-portugal-cuban-model", "0153a700-7e93-4e40-8faf-dfc7796b4a5e"],
  'portugal|franco': ["078-portugal-franco-model", "71bea839-5451-453b-afa6-a71ccfad3ff2"],
  'portugal|anchor': ["080-portugal-anchor-model", "630c9de1-6288-4f11-934e-f23dbe02d409"],
  'france|rope': ["082-france-rope-model", "f2ff490d-4734-4d8e-b745-30d4e474512f"],
  'france|figaro': ["084-france-figaro-model", "d5ac1af3-4687-41da-a6d4-126bf3f6cbc8"],
  'france|cuban': ["086-france-cuban-model", "85a7cb9a-9bf8-4a27-9838-d46f2a55855b"],
  'france|franco': ["088-france-franco-model", "a07a1ba4-047a-4367-8348-ac197b2cc5b4"],
  'france|anchor': ["090-france-anchor-model", "46aa542d-e796-461a-aec4-be23378c6a19"],
  'croatia|rope': ["092-croatia-rope-model", "78c71d95-58e1-4708-9a41-5e54a3426011"],
  'croatia|figaro': ["094-croatia-figaro-model", "79b48591-d78a-470a-af00-490a380e2af1"],
  'croatia|cuban': ["096-croatia-cuban-model", "e8ed5aa3-2003-43f8-bc6e-388b44c4fe72"],
  'croatia|franco': ["098-croatia-franco-model", "d2e020d8-51bc-4e9b-8b02-8df7e7ad191f"],
  'croatia|anchor': ["100-croatia-anchor-model", "10672107-1584-4ea3-a7ca-906a2a5b64a0"],
  'japan|rope': ["102-japan-rope-model", "133d78de-3830-48c4-ab7e-f794f0273dc1"],
  'japan|figaro': ["104-japan-figaro-model", "ba555438-88ec-4992-a17c-cba5d322d344"],
  'japan|cuban': ["106-japan-cuban-model", "d75f70db-dde5-472e-84c8-e73199ecb7d1"],
  'japan|franco': ["108-japan-franco-model", "5d068abc-f5a0-4909-8d1f-65d6f36de088"],
  'japan|anchor': ["110-japan-anchor-model", "3f2ee3b5-6ea5-46b1-b685-3c2b630867cd"],
  'iran|rope': ["112-iran-rope-model", "0557d21e-f756-4166-8c31-775b11b11dc5"],
  'iran|figaro': ["114-iran-figaro-model", "86c443e1-57f6-4328-a949-90bce0e34a95"],
  'iran|cuban': ["116-iran-cuban-model", "4e3e64f2-97e2-4d9e-a9b8-82299521fbc0"],
  'iran|franco': ["118-iran-franco-model", "aed9457c-78fb-49bc-9531-9ee53a3a499d"],
  'iran|anchor': ["120-iran-anchor-model", "a229edea-ec9d-4610-a503-afbd6123e4e1"],
  'switzerland|rope': ["122-switzerland-rope-model", "6801c489-0fbe-4452-ab0b-2500f87e5147"],
  'switzerland|figaro': ["124-switzerland-figaro-model", "3a76411d-fdc6-431f-bc8f-961276a6f1fb"],
  'switzerland|cuban': ["126-switzerland-cuban-model", "ae3a32cc-708b-4427-81b3-7d802c402062"],
  'switzerland|franco': ["128-switzerland-franco-model", "cfa6243f-364c-48df-b8f9-245c8f6ce32f"],
  'switzerland|anchor': ["130-switzerland-anchor-model", "4a57b83c-150f-4640-8b62-21d49a47d71a"],
  'belgium|rope': ["132-belgium-rope-model", "ceed3974-bc9f-4602-bc74-9fc13c07ab47"],
  'belgium|figaro': ["134-belgium-figaro-model", "04191aee-840a-4b40-8f3a-1efd67db1e9a"],
  'belgium|cuban': ["136-belgium-cuban-model", "1cd92b44-f24c-4313-9469-99ffe180c271"],
  'belgium|franco': ["138-belgium-franco-model", "803d9465-1106-4997-b65c-f6e385a2fd79"],
  'belgium|anchor': ["140-belgium-anchor-model", "aa49076b-80ed-4b0d-a211-029f75247f1f"],
  'england|rope': ["142-england-rope-model", "4648b59e-cb87-4999-a201-1d21a473b22a"],
  'england|figaro': ["144-england-figaro-model", "a2166edc-0dff-465d-8e42-b4481ea08b70"],
  'england|cuban': ["146-england-cuban-model", "52872ff4-de34-46a2-8c26-1aea9be5c806"],
  'england|franco': ["148-england-franco-model", "459496d0-c499-400e-b505-ad01bf2eb6a2"],
  'england|anchor': ["150-england-anchor-model", "2b53e034-7205-4d5f-9108-03928915d7d9"],
  'ivory coast|rope': ["152-ivory-coast-rope-model", "8f78f2ee-c012-444f-8f7e-29f5879fe7a9"],
  'ivory coast|figaro': ["154-ivory-coast-figaro-model", "c38979e1-a059-4ace-b244-c1df96ff7290"],
  'ivory coast|cuban': ["156-ivory-coast-cuban-model", "c69ec0ec-b663-4032-9af1-32375f077fd4"],
  'ivory coast|franco': ["158-ivory-coast-franco-model", "bff89205-81c9-4584-a325-21b7d45fcb45"],
  'ivory coast|anchor': ["160-ivory-coast-anchor-model", "a6a5b9dd-dde9-47c7-b698-daaae9836b2e"],
  'colombia|rope': ["162-colombia-rope-model", "77af8164-9cf3-4a60-afce-b249eae449ca"],
  'colombia|figaro': ["164-colombia-figaro-model", "cd5ef3f6-fd19-463e-8122-6996dd0a805c"],
  'colombia|cuban': ["166-colombia-cuban-model", "b149ce34-d95c-414f-977f-77fb74b87b31"],
  'colombia|franco': ["168-colombia-franco-model", "0dc44088-f0c7-427f-9ff8-46916c501ac6"],
  'colombia|anchor': ["170-colombia-anchor-model", "1538c667-e6c0-42e0-9143-d9fbea8ac3b9"],
  'austria|rope': ["172-austria-rope-model", "fdf0a81b-76ff-44bb-9c9c-64b391befad4"],
  'austria|figaro': ["174-austria-figaro-model", "32bbec14-5c2e-40c9-bdb3-cc859bd197ce"],
  'austria|cuban': ["176-austria-cuban-model", "6ef133ef-37ad-4a96-b47a-787ee4531a06"],
  'austria|franco': ["178-austria-franco-model", "c68beca6-cb5c-45e7-8410-eff625c25be8"],
  'austria|anchor': ["180-austria-anchor-model", "419916ba-46bb-4c65-afb6-6910c7a797c2"],
  'uruguay|rope': ["182-uruguay-rope-model", "6a0f19ca-09a7-4500-ba65-ba34e94e0da2"],
  'uruguay|figaro': ["184-uruguay-figaro-model", "e32f7461-da2e-4370-8961-b7a6e3831cfa"],
  'uruguay|cuban': ["186-uruguay-cuban-model", "8ae6830e-5bc4-4a5e-a9c5-92baf428a4e9"],
  'uruguay|franco': ["188-uruguay-franco-model", "08cbad4b-3105-40d1-9f6d-9785b78641da"],
  'uruguay|anchor': ["190-uruguay-anchor-model", "5dfb0a84-041e-4163-8429-9a792d640a76"],
  'south korea|rope': ["192-south-korea-rope-model", "05cab9db-bce4-48ed-9b08-e1483b167226"],
  'south korea|figaro': ["194-south-korea-figaro-model", "77c7469c-60d3-4450-839a-f238c92d2456"],
  'south korea|cuban': ["196-south-korea-cuban-model", "179163c6-e38c-4d59-b195-465c98521ef8"],
  'south korea|franco': ["198-south-korea-franco-model", "ca15e4b1-473a-415b-8ff2-684eb3774ce6"],
  'south korea|anchor': ["200-south-korea-anchor-model", "c8b806d2-a8fd-45e5-9c5e-6fda01227195"],
  'brazil|rope': ["202-brazil-rope-model", "c8007e6c-a1ee-46d3-bd9d-214ba238a7ce"],
  'brazil|figaro': ["204-brazil-figaro-model", "ebad5be6-1773-40a7-b916-f5efb5fe0d71"],
  'brazil|cuban': ["206-brazil-cuban-model", "1d930d5a-e21a-4cf3-bebe-760105099e74"],
  'brazil|franco': ["208-brazil-franco-model", "ae130462-d44c-457c-9549-ad9cb3f04c26"],
  'brazil|anchor': ["210-brazil-anchor-model", "1c6e16cf-3bca-4266-84bb-69fc524f675b"],
  'germany|rope': ["212-germany-rope-model", "d6467544-ee7b-4f50-bdfa-fa064c17522c"],
  'germany|figaro': ["214-germany-figaro-model", "de63aa7f-4e6f-44d1-bfa9-c5cee793556e"],
  'germany|cuban': ["216-germany-cuban-model", "98862fc4-96ac-4b61-8b68-05426b0999bd"],
  'germany|franco': ["218-germany-franco-model", "ed0ea583-7c56-483c-934b-bfccfad2b0ba"],
  'germany|anchor': ["220-germany-anchor-model", "2b8f9189-1826-46d4-9e46-464f768eb147"],
};

class WorldCupProduct extends HTMLElement {
  constructor() {
    super();
    this.unsubscribeVariantChange = undefined;
  }

  connectedCallback() {
    this.mediaMap = this.getMediaMap();
    this.productInfo = this.closest('product-info');
    this.bindVariantChanges();
    this.bindUnavailableOptionGuards();
    this.updateVariantAvailability();
    this.selectCountryOnInitialLoad();

    window.requestAnimationFrame(() => {
      this.applyMediaGroup(this.getCurrentVariant());
    });
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange?.();
  }

  bindVariantChanges() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!this.productInfo || data.sectionId !== this.productInfo.dataset.section) return;

      window.requestAnimationFrame(() => {
        this.updateVariantAvailability();
        this.applyMediaGroup(data.variant);
      });
    });
  }

  bindUnavailableOptionGuards() {
    this.addEventListener(
      'click',
      (event) => {
        const label = event.target.closest('label[for]');
        if (!label || !this.contains(label)) return;

        const input = this.getInputForLabel(label);
        if (!this.isUnavailableOption(input)) return;

        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    this.addEventListener(
      'change',
      (event) => {
        if (!this.isUnavailableOption(event.target)) return;

        event.preventDefault();
        event.stopPropagation();
        this.restoreAvailableCountry();
      },
      true
    );
  }

  selectCountryOnInitialLoad() {
    if (new URLSearchParams(window.location.search).has('variant')) return;

    const requestedCountry = this.getRequestedCountry() || 'canada';
    const countryOption = Array.from(this.querySelectorAll('.world-cup-option--country input[type="radio"]')).find(
      (input) => this.normalizeCountry(input.value) === requestedCountry
    );

    if (!countryOption || countryOption.checked || countryOption.classList.contains('disabled')) return;

    window.requestAnimationFrame(() => {
      countryOption.checked = true;
      countryOption.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  getRequestedCountry() {
    const params = new URLSearchParams(window.location.search);
    const country = params.get('country') || params.get('flag');

    return country ? this.normalizeCountry(country) : null;
  }

  normalizeCountry(country) {
    return this.normalizeOption(country);
  }

  normalizeOption(value) {
    const normalizedValue = String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');

    if (normalizedValue === 'columbia') return 'colombia';

    return normalizedValue;
  }

  getMediaMap() {
    const mediaMapScript = this.querySelector('[data-world-cup-media-map]');
    if (!mediaMapScript) return { mediaIds: [], variants: [] };

    try {
      return JSON.parse(mediaMapScript.textContent);
    } catch (error) {
      console.error(error);
      return { mediaIds: [], variants: [] };
    }
  }

  getCurrentVariant() {
    const selectedVariantScript = this.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariantScript) return null;

    try {
      return JSON.parse(selectedVariantScript.textContent);
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  getSelectedStyle() {
    return this.querySelector('.world-cup-option--style input[type="radio"]:checked')?.value || null;
  }

  getSelectedCountry() {
    return this.querySelector('.world-cup-option--country input[type="radio"]:checked')?.value || null;
  }

  getInputForLabel(label) {
    const inputId = label?.getAttribute('for');
    if (!inputId) return null;

    return Array.from(this.querySelectorAll('input[type="radio"]')).find((input) => input.id === inputId) || null;
  }

  getVariantForSelection({ style = this.getSelectedStyle(), country = this.getSelectedCountry() } = {}) {
    if (!style || !country) return null;

    return this.mediaMap.variants.find((variant) => {
      const options = variant.options || [];

      return options.includes(style) && options.includes(country);
    });
  }

  updateVariantAvailability() {
    const countryInputs = Array.from(this.querySelectorAll('.world-cup-option--country input[type="radio"]'));
    const selectedStyle = this.getSelectedStyle();

    if (!selectedStyle || countryInputs.length === 0) return;

    countryInputs.forEach((input) => {
      const matchingVariant = this.getVariantForSelection({ style: selectedStyle, country: input.value });
      const unavailable = !matchingVariant || !matchingVariant.available;

      this.setOptionUnavailable(input, unavailable);
    });

    const selectedCountry = this.querySelector('.world-cup-option--country input[type="radio"]:checked');
    if (this.isUnavailableOption(selectedCountry)) this.restoreAvailableCountry();
  }

  restoreAvailableCountry() {
    const availableCountry = Array.from(
      this.querySelectorAll('.world-cup-option--country input[type="radio"]')
    ).find((input) => !this.isUnavailableOption(input));

    if (!availableCountry || availableCountry.checked) return;

    availableCountry.checked = true;
    availableCountry.dispatchEvent(new Event('change', { bubbles: true }));
  }

  setOptionUnavailable(input, unavailable) {
    if (!input) return;

    input.disabled = unavailable;
    input.classList.toggle('disabled', unavailable);
    input.toggleAttribute('aria-disabled', unavailable);
    input.dataset.worldCupUnavailable = unavailable ? 'true' : 'false';
  }

  isUnavailableOption(input) {
    return input?.disabled || input?.classList?.contains('disabled') || input?.dataset?.worldCupUnavailable === 'true';
  }

  getVariantFeaturedMediaId(variant) {
    return variant?.featured_media?.id || variant?.featuredMediaId || null;
  }

  getMediaGroup(variant) {
    const featuredMediaId = this.getVariantFeaturedMediaId(variant);
    const mediaIds = this.mediaMap.mediaIds.map((mediaId) => String(mediaId));
    const featuredMediaIdString = featuredMediaId ? String(featuredMediaId) : null;
    const explicitMediaGroup = this.getExplicitMediaGroup(variant, featuredMediaIdString);

    if (explicitMediaGroup.length > 0) return explicitMediaGroup;

    const sequentialMediaGroup = this.getSequentialMediaGroup(featuredMediaIdString);

    return sequentialMediaGroup.length ? sequentialMediaGroup : mediaIds.slice(0, 1);
  }

  getSequentialMediaGroup(featuredMediaId) {
    const mediaIds = this.mediaMap.mediaIds.map((mediaId) => String(mediaId));
    const featuredMediaIdString = featuredMediaId ? String(featuredMediaId) : null;

    if (!featuredMediaIdString || mediaIds.length === 0) return [];

    const assignedMediaIds = this.getAssignedMediaIds();
    const startIndex = mediaIds.indexOf(featuredMediaIdString);

    if (startIndex === -1) return [featuredMediaIdString];

    const group = [];

    for (let index = startIndex; index < mediaIds.length; index += 1) {
      const mediaId = mediaIds[index];

      if (index > startIndex && assignedMediaIds.has(mediaId)) break;

      group.push(mediaId);
    }

    return group.length ? group : [featuredMediaIdString];
  }

  getAssignedMediaIds() {
    const assignedMediaIds = new Set(
      this.mediaMap.variants
        .map((variantData) => variantData.featuredMediaId)
        .filter(Boolean)
        .map((mediaId) => String(mediaId))
    );

    Object.values(WORLD_CUP_ASSIGNED_MEDIA_KEYS).forEach((mediaKey) => {
      const mediaId = this.getFirstMediaIdForKey(mediaKey);

      if (mediaId) assignedMediaIds.add(String(mediaId));
    });

    return assignedMediaIds;
  }

  getExplicitMediaGroup(variant, featuredMediaId) {
    const { country, style } = this.getVariantCountryAndStyle(variant);
    const assignedMediaKey = WORLD_CUP_ASSIGNED_MEDIA_KEYS[`${country}|${style}`];
    const modelMediaKey = WORLD_CUP_MODEL_MEDIA_KEYS[`${country}|${style}`];
    const assignedMediaId = this.getFirstMediaIdForKey(assignedMediaKey);
    const excludedModelIds = new Set([assignedMediaId, featuredMediaId].filter(Boolean));
    const modelMediaId = this.getFirstMediaIdForKey(modelMediaKey, excludedModelIds);
    const fallbackFeaturedMediaId =
      !assignedMediaId && this.isSafeFallbackFeaturedMedia(variant, featuredMediaId) ? featuredMediaId : null;
    const baseAssignedMediaId = assignedMediaId || fallbackFeaturedMediaId;
    const sequentialMediaGroup = this.getSequentialMediaGroup(baseAssignedMediaId);
    const sequentialModelMediaId = sequentialMediaGroup.find((mediaId) => mediaId !== baseAssignedMediaId);
    const explicitMediaIds = [baseAssignedMediaId, modelMediaId || sequentialModelMediaId].filter(Boolean);

    if (explicitMediaIds.length > 0) return Array.from(new Set(explicitMediaIds));
    if (!featuredMediaId || !this.isSafeFallbackFeaturedMedia(variant, featuredMediaId)) return [];

    return this.getSequentialMediaGroup(featuredMediaId);
  }

  isSafeFallbackFeaturedMedia(variant, featuredMediaId) {
    if (!variant || !featuredMediaId) return false;

    const { country, style } = this.getVariantCountryAndStyle(variant);
    const variantsWithSameMedia = this.mediaMap.variants.filter(
      (variantData) => String(variantData.featuredMediaId || '') === String(featuredMediaId)
    );

    if (variantsWithSameMedia.length === 0) return true;

    const countries = new Set();
    const styles = new Set();

    variantsWithSameMedia.forEach((variantData) => {
      const variantOptions = this.getVariantCountryAndStyle(variantData);

      if (variantOptions.country) countries.add(variantOptions.country);
      if (variantOptions.style) styles.add(variantOptions.style);
    });

    if (countries.size > 1 || !countries.has(country)) return false;
    if (styles.size > 1 && style !== 'rope') return false;

    return true;
  }

  getVariantCountryAndStyle(variant) {
    const options = variant?.options || [];
    const style =
      options.find((option) => WORLD_CUP_STYLE_VALUES.has(this.normalizeOption(option))) || this.getSelectedStyle();
    const country =
      options.find((option) => option && this.normalizeOption(option) !== this.normalizeOption(style)) ||
      this.getSelectedCountry();

    return {
      country: this.normalizeOption(country),
      style: this.normalizeOption(style),
    };
  }

  getFirstMediaIdForKey(mediaKey, excludedMediaIds = new Set()) {
    if (!mediaKey) return null;

    const mediaKeys = Array.isArray(mediaKey) ? mediaKey : [mediaKey];
    const media = this.getMediaItems().find(
      (mediaItem) => mediaKeys.includes(this.getMediaFileKey(mediaItem.src)) && !excludedMediaIds.has(mediaItem.id)
    );

    return media?.id || null;
  }

  getMediaItems() {
    if (Array.isArray(this.mediaMap.media)) {
      return this.mediaMap.media
        .filter((media) => media?.id)
        .map((media) => ({
          id: String(media.id),
          src: media.src || '',
        }));
    }

    return this.mediaMap.mediaIds.map((mediaId) => ({ id: String(mediaId), src: '' }));
  }

  getMediaFileKey(src) {
    if (!src) return '';

    const filename = src
      .split('?')[0]
      .split('/')
      .pop()
      .replace(/\.[a-z0-9]+$/i, '');

    return filename
      .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '')
      .replace(/_\d+_\d+_[a-z]$/i, '')
      .toLowerCase();
  }

  applyMediaGroup(variant) {
    const mediaGallery = this.productInfo?.querySelector('media-gallery');
    if (!mediaGallery || !variant) return;

    const mediaGroup = this.getMediaGroup(variant);
    const visibleMediaIds = new Set(mediaGroup);
    const assignedMediaIds = this.getAssignedMediaIds();
    const sectionId = this.productInfo.dataset.section;

    mediaGallery.querySelectorAll('[data-media-id]').forEach((item) => {
      const mediaId = this.getIdFromSectionMediaId(item.dataset.mediaId);
      this.setMediaRole(item, assignedMediaIds.has(mediaId));
      this.setMediaVisibility(item, visibleMediaIds.has(mediaId));
    });

    mediaGallery.querySelectorAll('[data-target]').forEach((item) => {
      const mediaId = this.getIdFromSectionMediaId(item.dataset.target);
      this.setMediaRole(item, assignedMediaIds.has(mediaId));
      this.setMediaVisibility(item, visibleMediaIds.has(mediaId));
    });

    mediaGallery.querySelectorAll('slider-component').forEach((slider) => slider.resetPages?.());
    mediaGallery.setActiveMedia?.(`${sectionId}-${mediaGroup[0]}`, false);
  }

  setMediaVisibility(item, visible) {
    item.classList.toggle('world-cup-media-hidden', !visible);
    item.toggleAttribute('hidden', !visible);
  }

  setMediaRole(item, assigned) {
    item.classList.toggle('world-cup-media-assigned', assigned);
  }

  getIdFromSectionMediaId(sectionMediaId) {
    return String(sectionMediaId || '').split('-').pop();
  }
}

if (!customElements.get('world-cup-product')) {
  customElements.define('world-cup-product', WorldCupProduct);
}
